import { AlertCircle, LoaderCircle } from 'lucide-react'

type EntitlementUnavailableVariant = 'access' | 'plan' | 'checkout'

const COPY: Record<
  EntitlementUnavailableVariant,
  { title?: string; retrying: string; terminal: string }
> = {
  access: {
    title: 'Abonelik bilgisi şu an alınamıyor',
    retrying: 'Geçici bir servis sorunu nedeniyle erişiminiz doğrulanamadı. Otomatik olarak yeniden deneniyor.',
    terminal: 'Erişiminiz doğrulanamadı. Sayfayı yenileyin; sorun sürerse çıkıp yeniden giriş yapın.',
  },
  plan: {
    title: 'Abonelik bilgisi şu an alınamıyor',
    retrying: 'Geçici bir servis sorunu nedeniyle plan bilginiz doğrulanamadı. Otomatik olarak yeniden deneniyor.',
    terminal: 'Plan bilginiz doğrulanamadı. Sayfayı yenileyin; sorun sürerse çıkıp yeniden giriş yapın.',
  },
  checkout: {
    retrying: 'Plan bilginiz doğrulanamadı. Ödemeye devam etmeden önce yeniden deneniyor.',
    terminal: 'Plan bilginiz doğrulanamadı. Ödemeye devam etmeden önce sayfayı yenileyin.',
  },
}

export function EntitlementUnavailable({
  variant = 'access',
  compact = false,
  retrying = true,
}: {
  variant?: EntitlementUnavailableVariant
  compact?: boolean
  /** Arka planda otomatik yeniden deneme var mi? Kalici (4xx) hatada false — yalan vaat vermeyelim. */
  retrying?: boolean
}) {
  const copy = COPY[variant]
  const description = retrying ? copy.retrying : copy.terminal
  const Icon = retrying ? LoaderCircle : AlertCircle
  const iconMotion = retrying ? 'animate-spin' : ''

  if (compact) {
    return (
      <div className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3" role="status">
        <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${iconMotion} text-white/50`} aria-hidden="true" />
        <div>
          {copy.title && <h3 className="text-sm font-medium text-white">{copy.title}</h3>}
          <p className={`${copy.title ? 'mt-1 ' : ''}text-xs text-white/50`}>{description}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16" role="status">
      <div className="rounded-full border border-white/10 bg-white/5 p-4">
        <Icon className={`h-8 w-8 ${iconMotion} text-white/50`} aria-hidden="true" />
      </div>
      <div className="text-center">
        {copy.title && <h3 className="text-lg font-semibold text-white">{copy.title}</h3>}
        <p className="mt-1 text-sm text-white/40">{description}</p>
      </div>
    </div>
  )
}
